import React from 'react'

import Progress from 'common/components/feedback/Progress'

import { parseZoneFormat } from 'common/dateFormatters'

import './DaysLeftForRequestingReimbursement.less'

interface DaysLeftForRequestingReimbursementProps {
  daysLeft: number
  startDate: Date
  endDate: Date
  translate: (key: string) => string
}

const DaysLeftForRequestingReimbursement: React.FC<DaysLeftForRequestingReimbursementProps> = ({
  daysLeft,
  startDate,
  endDate,
  translate,
}) => {
  const lastDayToSubmit = new Date()
  lastDayToSubmit.setDate(new Date().getDate() + daysLeft)

  return (
    <div className="days_left_progress">
      <Progress
        type="circle"
        percent={(daysLeft * 100) / 90}
        format={() => (
          <>
            <h5 className="days_left_number">{daysLeft}</h5>
            <h6 className="days_left_label">{translate('summary.days-left-label')}</h6>
          </>
        )}
        strokeColor="#F46A40"
        strokeLinecap="square"
        strokeWidth={8}
      />
      <div className="pl-16">
        <h6 className="request_reimbursement_by">
          {translate('summary.request-reimbursement-by-description').replace(
            '[DATE]',
            parseZoneFormat(lastDayToSubmit),
          )}
        </h6>
        <h6 className="request_reimbursement_by_interval">
          {translate('summary.request-reimbursement-by-interval-description')
            .replace('[DAYS]', daysLeft.toString())
            .replace('[INTERVAL]', parseZoneFormat(startDate) + ' - ' + parseZoneFormat(endDate))}
        </h6>
      </div>
    </div>
  )
}

export default DaysLeftForRequestingReimbursement
